import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate, useLocation } from 'react-router-dom';
import { Breadcrumbs as MuiBreadcrumbs, Link, Typography } from '@mui/material';
import { NavigateNext, Home } from '@mui/icons-material';
import { categories } from '../data/categories';
import { calculators } from '../data/calculators';
const Breadcrumbs = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const pathParts = location.pathname.split('/').filter(Boolean);
    const getBreadcrumbs = () => {
        const crumbs = [
            { label: 'Home', path: '/', icon: _jsx(Home, { sx: { mr: 0.5, fontSize: 20 } }) },
        ];
        if (pathParts[0] === 'category' && pathParts[1]) {
            const category = categories.find((c) => c.id === pathParts[1]);
            if (category) {
                crumbs.push({ label: category.name, path: `/category/${category.id}` });
            }
        }
        if (pathParts[0] === 'calculator' && pathParts[1]) {
            const calculator = calculators.find((c) => c.id === pathParts[1]);
            if (calculator) {
                const category = categories.find((c) => c.id === calculator.category);
                if (category) {
                    crumbs.push({ label: category.name, path: `/category/${category.id}` });
                }
                crumbs.push({ label: calculator.name, path: `/calculator/${calculator.id}` });
            }
        }
        return crumbs;
    };
    const breadcrumbs = getBreadcrumbs();
    return (_jsx(MuiBreadcrumbs, { separator: _jsx(NavigateNext, { fontSize: "small" }), "aria-label": "breadcrumb", sx: { mb: 2 }, children: breadcrumbs.map((crumb, index) => {
            const isLast = index === breadcrumbs.length - 1;
            return isLast ? (_jsxs(Typography, { color: "text.primary", sx: { display: 'flex', alignItems: 'center' }, children: [crumb.icon, crumb.label] }, crumb.path)) : (_jsxs(Link, { component: "button", variant: "body1", onClick: () => navigate(crumb.path), sx: { display: 'flex', alignItems: 'center', cursor: 'pointer' }, children: [crumb.icon, crumb.label] }, crumb.path));
        }) }));
};
export default Breadcrumbs;
